import { render } from "./ToothAnnotations.vue?vue&type=template&id=b9d6792c&scoped=true"
import script from "./ToothAnnotations.vue?vue&type=script&lang=js"
export * from "./ToothAnnotations.vue?vue&type=script&lang=js"

import "./ToothAnnotations.vue?vue&type=style&index=0&id=b9d6792c&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9d6792c"]])

export default __exports__